import NotificationsTab from "@/components/NavBar/NotificationsTab";
import {type FC} from "react";

const NotificationPanel: FC = () => (
  <div className="border-neutral-white-dark absolute top-0 right-0 h-[75vh] w-full translate-y-20 overflow-auto rounded-md border bg-white shadow-2xl md:h-[60vh] md:w-1/2 md:shadow-md lg:w-1/3">
    <NotificationsTab />
  </div>
);

export default NotificationPanel;
